export * from "./system.information";
